import $ from 'jquery';

function ContactCtrl() {
  this.$formMailReceptionPopupLink = $('a[href^="#formMailReceptionPopup"]');
  this.$formMailReceptionPopup = $('#formMailReceptionPopup');
  this.$formMailReceptionPopupClose = $('#formMailReceptionPopupClose');
  this.$popupBox = this.$formMailReceptionPopup.find('.form-mail-reception-popup__box');

  this.open = this.open.bind(this);
  this.close = this.close.bind(this);
  this.init();
}


ContactCtrl.prototype = {
  init() {
    this.$formMailReceptionPopupLink.on('click', this.open);
    this.$formMailReceptionPopupClose.on('click', this.close);
    this.$formMailReceptionPopup.on('click', this.close);
    this.$popupBox.on('click', this.propagation);
  },

  propagation(e) {
    e.stopPropagation();
  },

  open(e) {
    e.preventDefault();
    this.$formMailReceptionPopup.addClass('opened');
  },

  close(e) {
    e.preventDefault();
    this.$formMailReceptionPopup.removeClass('opened');
  }
};

export default ContactCtrl;